'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024 from "./presto.types$-Two-Factor-Auth-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$58() {
  this.aHq = null;
  this.aHo = null;
  this.aHp = false;
  this.aHm = null;
  this.aHn = false;
  this.aHr = false;
  this.aHs = false;
  this.aHq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$58 as $c_Lpresto_CredentialsView$$anon$58 };
$p = $c_Lpresto_CredentialsView$$anon$58.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$58;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$58() {
}
export { $h_Lpresto_CredentialsView$$anon$58 as $h_Lpresto_CredentialsView$$anon$58 };
$h_Lpresto_CredentialsView$$anon$58.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.aHq;
});
$p.t = (function() {
  if ((!this.aHp)) {
    this.aHo = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHp = true;
  }
  return this.aHo;
});
$p.ag = (function() {
  if ((!this.aHn)) {
    this.aHm = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024.$m_Lpresto_types$TwoFactorAuthId$().vn(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHn = true;
  }
  return this.aHm;
});
$p.v = (function() {
  if ((!this.aHs)) {
    this.aHr = false;
    this.aHs = true;
  }
  return this.aHr;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_CredentialsView$$anon$58 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$58, "presto.CredentialsView$$anon$58", ({
  G7: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$58 as $d_Lpresto_CredentialsView$$anon$58 };
//# sourceMappingURL=presto.-Credentials-View$$anon$58.js.map
